import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { IlloUnderwaterPlants } from "../../../atoms/Illustrations"
import { useSelector } from "react-redux"
import { getShouldFillOutBankInfo } from "../../../../../derivedSelectors"
import { Steps } from "../Workflow/Steps"
import WeWillTakeItFromHere from "../WeWillTakeItFromHere"
import { BankInfoOptionButtons } from "./BankInfoOptionButtons"
import { useProgressTracker } from "../../ProgressTracker"
import { useBenefitEnrollmentFlow } from "../BenefitEnrollmentFlowModal"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.SKIP_CONNECT_INSURANCE
const SkipConnectInsuranceView: FC = () => {
  const { setProgress } = useProgressTracker()
  const { onExit } = useBenefitEnrollmentFlow()
  const needsBankInfo = useSelector(getShouldFillOutBankInfo)
  useStateMachine(ViewName, null)

  setProgress(2, "CONNECT YOUR INSURANCE")

  return (
    <div>
      <Spacer height={1.5} />
      <FlexRowCenter>
        <IlloUnderwaterPlants />
      </FlexRowCenter>
      <Spacer height={2} />
      <H2 variant="dark">
        {needsBankInfo
          ? l`You've skipped connecting to your insurance provider.`
          : l`You've skipped connecting to your insurance provider, so you're done for now.`}
      </H2>
      <Spacer height={0.5} />
      <WeWillTakeItFromHere />
      {needsBankInfo && (
        <>
          <Spacer height={3} />
          <Body color="black-80">{l`Next, update your bank info so we can direct reimbursement funds to the right account.`}</Body>
        </>
      )}
      <Spacer height={3} />
      <BankInfoOptionButtons {...{ needsBankInfo, onExit }} />
    </div>
  )
}

export { SkipConnectInsuranceView }
